<div class="formulario">
	<div class="form-group">
		<input placeholder="Title" type="text" [(ngModel)]="nuevaTarea.titulo">
	</div>
	<div class="form-group">
		<input type="text" placeholder="Description" [(ngModel)]="nuevaTarea.descripcion">
	</div>
	<button class="btn" (click)="onClick()">Save</button>
</div>

<!-- {{nuevaTarea | json }} -->